import Home from "../Pages/Public/Home/Home";

import Consulation from "../Pages/Public/Consulation/Consulation";

const PublicRoute = [
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/consulation",
    exact: true,
    element: <Consulation />,
  },
];

export default PublicRoute;
